/**
 * Every visible string on the player profile screen, declared once.
 *
 * Straight ASCII apostrophes only, matching
 * `apps/app/src/features/fanProfile/fanProfileCopy.ts`. American English,
 * no en dash, no em dash.
 */

export const PLAYER_PROFILE_HEADING = "Player";
export const PLAYER_TABS_LABEL = "Player sections";
export const PLAYER_TAB_INFO_LABEL = "Info";
export const PLAYER_TAB_STATS_LABEL = "Stats";
export const PLAYER_TAB_GAME_LOG_LABEL = "Game log";
export const PLAYER_INFO_TEAM_LABEL = "Team";
export const PLAYER_INFO_POSITION_LABEL = "Position";
export const PLAYER_INFO_NUMBER_LABEL = "Number";
export const PLAYER_INFO_STATUS_LABEL = "Status";
export const PLAYER_INFO_HEIGHT_LABEL = "Height";
export const PLAYER_INFO_WEIGHT_LABEL = "Weight";
export const PLAYER_INFO_AGE_LABEL = "Age";
export const PLAYER_INFO_EXPERIENCE_LABEL = "Experience";
export const PLAYER_INFO_COLLEGE_LABEL = "College";
export const PLAYER_STATUS_ACTIVE_LABEL = "Active";
export const PLAYER_INFO_EMPTY_HEADLINE = "No details yet";
export const PLAYER_INFO_EMPTY_BODY =
  "Details show up here once this player's team posts its roster.";
export const PLAYER_INFO_LOADING_LABEL = "Loading player details";
export const PLAYER_STATS_NOT_STARTED_HEADLINE = "No stats yet this season";
export const PLAYER_STATS_NOT_STARTED_BODY =
  "Stats show up here once this player gets into a game.";
export const PLAYER_GAME_LOG_NOT_STARTED_HEADLINE = "No games yet this season";
export const PLAYER_GAME_LOG_NOT_STARTED_BODY =
  "Each game this player plays shows up here.";
export const PLAYER_UNAVAILABLE_HEADLINE = "Player not found";
export const PLAYER_UNAVAILABLE_BODY =
  "Open a player from a roster, a lineup, or a box score.";
export const PLAYER_NO_DETAILS_LABEL = "No number or position yet";
